<template>
    <div class="row">
        <div class="col-lg-6 order-2 order-lg-0">
            <b-overlay :show="loading" opacity="0.2">
                <form :name="form.name" :method="form.method" ref="form" :action="form.action" autocomplete="off">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">İsim Soyisim</label>
                            <input v-card.holder class="form-control" type="text" v-model="fullName" placeholder="İsim Soyisim" />
                            <input :name="form.holderFullName" type="hidden" id="cardHolderName" :value="fullName"> 
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kart Numarası</label>
                            <input v-card.card-number class="form-control" v-mask="'#### #### #### ####'" type="text"  v-model="cardNumber"  placeholder="Kart Numarası"/>
                            <input :name="form.cardNumber" type="hidden" id="ccno" :value="cardNumber"> 
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Ay</label>
                            <select v-card.expire class="form-control" v-model="expireMonth">
                                <option :value="null">Ay</option>
                                <option v-for="m in months" :key="m.value" :value="m.text">{{ m.text }}</option>
                            </select>
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Yıl</label>
                            <select v-card.expire class="form-control" v-model="expireYear">
                                <option :value="null">Yıl</option>
                                <option v-for="y in years" :key="y.value" :value="y.value">{{ y.text }}</option>
                            </select>
                            <input :name="form.expireDate" type="hidden" id="expDate" :value="expireYear+''+expireMonth"> 
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">CVC</label>
                            <input v-card.cvc class="form-control" type="text" v-model="cvc"  v-mask="'####'" placeholder="CVC"/>
                            <input :name="form.cvc" type="hidden" id="cvc" :value="cvc"> 
                        </div>
                        <div class="col-12 mb-1" v-if="canInstallment">
                            <b-form-radio-group v-model="installment" :options="c_installments">
                            </b-form-radio-group>
                        </div>
                        <div class="col-12">
                            <div class="bg-light text-right rounded p-1">
                                <div class="d-flex align-items-center mb-1">
                                    <span class="text-muted h4 mb-0 mr-1 text-nowrap">Ödenecek Tutar: </span>
                                    <v-currency-input input-class="text-right currency-font-size" :value="amount" v-on:updateValue="value => $emit('update:amount',value)"></v-currency-input>
                                    <span class="h4 mb-0 ml-1">₺</span>
                                </div>
                                <button type="button" class="btn btn-success w-100" v-on:click="pay">Öde</button>
                            </div>
                        </div>
                    </div>

                    <input name="XID" type="hidden" id="XID" :value="xid">
                    <input name="digest" type="hidden" id="digest" :value="digest">
                    <input name="posnetData" type="hidden" id="posnetData" :value="posnetData1">
                    <input name="posnetData2" type="hidden" id="posnetData2" :value="posnetData2">
                    <input name="amount" type="hidden" id="amount" :value="c_amount">
                    <input name="installment" type="hidden" id="installment" :value="installment">
                    <input name="merchantReturnURL" type="hidden" id="merchantReturnURL" :value="c_merchantReturnUrl"> 
                    <input type="hidden" v-for="param in parameters" :key="param.Id" :value="param.Value" :name="param.Key" />
                </form>
            </b-overlay>
        </div>
        <div class="col-lg-6 order-0 order-lg-2">
            <div class="d-flex justify-content-center">
                <b-img class="mt-2 bank-logo" :src="logo" height="80" />
            </div>
            <div class="d-flex justify-content-center card-box align-items-center p-2">
                <v-credit-card  ref="card"
                                :card-number="cardNumber" 
                                :expire-month="expireMonth" 
                                :expire-year="expireYear" 
                                :cvc="cvc" 
                                :holder="fullName"></v-credit-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BOverlay,BFormRadio,BFormRadioGroup,BImg } from 'bootstrap-vue'
import { BankApi } from '@/api/bank'
import { PaymentApi } from '@/api/payment'
import randomatic from 'randomatic'
import VCreditCard from '@/components/v-credit-card/VCreditCard.vue'
import { cardDirective } from '@/components/v-credit-card/index'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import moment from 'moment'

export default {
    components:{
        BOverlay,
        BFormRadio,
        BFormRadioGroup,
        VCreditCard,
        VCurrencyInput,
        BImg
    },
    props:{
        bankValue:Number,
        code:String,
        amount:Number,
        amountStr:String,
        logo:String,
        canInstallment:Boolean,
        installments:{
            type:Array,
            default:()=>[]
        }
    },
    directives:{
        "card":cardDirective
    },
    data() {
        return {
            digest:null,
            posnetData1:null,
            posnetData2:null,
            loading:false,
            parameters:[],
            fullName:null,
            cardNumber:null,
            expireMonth:null,
            expireYear:null,
            expireDate:null,
            cvc:null,
            hash:null,
            months:[],
            years:[],
            installment:"",
            xid: randomatic("Aa0",20),
            form:{
                name:'yapikredi_pay_form',
                method:'post',
                action:'https://posnet.yapikredi.com.tr/3DSWebService/YKBPaymentService',
                holderFullName:'cardHolderName',
                cardNumber:'ccno',
                expireDate:'expDate',
                cvc:'cvc'
            },
        }
    },
    mounted(){
        this.getParameters()
        this.months = Array.from({ length: 12 }, (_, i) => i).map(i=>{
            return {
                text: i+1 < 10 ? `0${i+1}` : `${i+1}`,
                value:i+1
            }
        })
        this.years = Array.from({ length: 50 }, (_, i) => i).map(i=>{
            let year = moment().add(i,'years').format('YYYY')
            return {
                text: year,
                value: year.slice(-2)
            }
        })
    },
    methods:{
        getParameters(){
            this.loading = true
            BankApi.BankParameterList(this.bankValue).then(res=>{
                if(res.data.Success){
                    this.parameters = res.data.Data
                    this.loading = false
                } else this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        pay(e){
            e.preventDefault()
            this.loading = true
            try {
                const MERCHANT_ID = this.parameters.find(p=>p.Key == "mid")?.Value || ""
                const TERMINAL_ID = this.parameters.find(p=>p.Key == "tid")?.Value || ""
                const POSNET_ID = this.parameters.find(p=>p.Key == "posnetID")?.Value || ""
                const CURRENCY_CODE = this.parameters.find(p=>p.Key == "currencycode")?.Value || ""

                let calculateData = {
                    XId:this.xid,
                    Amount:this.c_amount,
                    CurrencyCode:CURRENCY_CODE,
                    Installment:this.installment,
                    CardHolderName:this.fullName,
                    CcNo:this.cardNumber,
                    ExpDate:this.expireYear+''+this.expireMonth,
                    Cvc:this.cvc,
                    MerchantId:MERCHANT_ID,
                    TerminalId:TERMINAL_ID,
                    PosnetId:POSNET_ID,
                }
                PaymentApi.PreparePayment({
                    Amount:this.amount,
                    OrderId:this.xid,
                    CardNumber:this.cardNumber,
                    FullName:this.fullName,
                    PaymentCode:this.code,
                    Bank:this.bankValue,
                    Installment:this.installment
                }).then(res => {
                    PaymentApi.PosnetCalculateData(calculateData).then(res=>{
                        if(res.data.approved == 1){
                            this.posnetData1 = res.data['oosRequestDataResponse']['data1']
                            this.posnetData2 = res.data['oosRequestDataResponse']['data2']
                            this.digest = res.data['oosRequestDataResponse']['sign']
                            this.$nextTick(()=>{
                                this.$refs.form.submit()
                            })
                        }else{
                            this.loading = false
                        }
                        
                    }).catch(err=>{
                        this.loading = false
                        console.log(err)
                    })
                })
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        }
    },
    computed:{
        c_amount(){
            return  parseInt(Number(this.amount*100).toFixed(0))
        },
        c_merchantReturnUrl(){
           return this.parameters.find(p=>p.Key == "merchantUrl")?.Value + '?bankvalue='+this.bankValue+'&paymentcode='+this.code+'&installment='+this.installment+'&orderid='+this.xid
        },
        c_installments(){
            return this.installments.map(t=> {
                return {
                    value:t.Value,
                    text:t.Text
                }
            })
        }
    }
}
</script>

<style>

</style>